import { IPartnerFlag } from 'clickNgo/entities/partner/models/partnerFlag'
import { I519Form } from 'clickNgo/models/crud/forms/i519Form'

export const mapPartnerFlagFrom519Crud = (data: I519Form): IPartnerFlag => ({
  entryId: data.EntryId || '',
  partnerId: data.PartnerId || '',
  code: data.Code || '',
  codeName: data.CodeName || '',
  startDate: new Date(data.StartDate),
  endDate: new Date(data.EndDate),
  newEffectiveDate: data.NewEffectiveDate ? new Date(data.NewEffectiveDate) : undefined,
  codeType: data.Type || '',
  status: data.Status,
  caption: data.Caption || '',
  comment: data.Comment || '',
  country: data.Country || '',
  market: data.Market || '',
  action: data.Action || '',
})
